import { ErrorMessage, Field, useFormikContext } from 'formik';
import React from 'react';
import { calcularValorComDesconto } from '../helper/calculoDesconto.js';
import CurrencyInput from './CurrencyInput.jsx';

export default function ValorComDesconto() {
    const { values } = useFormikContext();

    const result = calcularValorComDesconto(values.valorBase,values.valorDesconto);

    return <>

        <Field
            maskOptions={{ integerLimit:4,
                thousandsSeparatorSymbol: '' }}
            as={CurrencyInput}
            name="valorFinal"
            id="valorFinal"
            placeholder="Valor final com desconto"
            disabled={true}
            min={1}
            value={result}
        />
        <ErrorMessage
            component="span"
            name="valorFinal"
            style={{ color: 'red' }}
        />
    </>;
}
